import $ from 'jquery';


class CreateQuotation {

	constructor() {
		if ($("#create-quotation").length> 0) {
			this.init();
		}
	}

	init() {

		Vue.component('create-quotation-line',  () => import('../components/CreateQuotationItems.vue'));


		const self = this;
		let vm = new Vue({
			el: "#quotation-lines",
			data: {
				vat: 0,
				vatEnabled: false,
				discount: 0,
				items: window.items,
				selected: window.selected
			},
			methods: {
				update() {
					let amount = 0;
					let failed = false;
					let cansave = true;
					let inp = $("<input />").attr("type", "hidden").attr("name", "data");
					$(inp).val(JSON.stringify(this.selected));
					$("#injected_elements").html(inp);
					this.selected.forEach(item => {
						let amnt = 1 * item.amount;
						if (isNaN(amnt)) {
							failed = true;
							cansave = false;
						} else {
							amount += amnt;
						}

						if (item.item == 0) {
							cansave = false;
						}

					})

					let vat = 0;
					if (this.items.length > 0) {
						vat = this.items[0].vat;
					}

					$("#vat_perc").html(vat);


					if (this.vatEnabled == false) {
						vat = 0;
					}

					this.vat = vat;

					$("#vat_field").val(vat);

					if (failed) {
						$("#_amount").val("");
						$("#total").html("!!Invalid Amount!!")
					} else {
						$("#_amount").val(amount.toFixed(2));
					}

					let total = amount  - this.discount;


					$("#total").html(total.toFixed(2));
					$("#_vat").html("0");

					if (this.vatEnabled) {
						let v =  vat * total / 100;
						$("#_vat").html(v.toFixed(2));
						total += v;
					}

					$("#_total").html(total.toFixed(2));

					$("#total_string").html(self.stringTotal(total.toFixed(2)));


					if (cansave) {
						$("#quotation-save-button").prop("disabled", false);
					} else {
						$("#quotation-save-button").prop("disabled", true);
					}



				}
			}
		});

		setTimeout(() => {
			vm.update();
		}, 200);

		this.clientid = window.appclient_id;


		$("#apply_vat").change(e => {
			vm.$data.vatEnabled = $(e.target).prop("checked");
			vm.update();
		}).change();

		$("#billingentity_id").change(e => {
			let val = $("#billingentity_id").val();
			if (val) {
				$("#appclient_preview").prop("disabled", false);
			} else {
				$("#appclient_preview").prop("disabled", true);
			}
		}).change();

		$("#appclient_preview").click(e => {
			let val = $("#billingentity_id").val();
			$.ajax({
				data: {op: "clientInfo", id: this.clientid },
				success: (client, s) => {
					if (val != 0) {
						let temp = {};
						$(client.billingentities).each((i, cl) => {
							if (cl.id == val){
								temp = cl;
								temp.companyname = temp.name;
							}
						})

						client = temp;
					}
					$("#_client_name").html(client.companyname);
					$("#_client_phone").html(client.phone);
					$("#_client_mof").html(client.mof);
					$("#_client_fax").html(client.fax);
					$("#_client_address").html(client.line1 + "<br>" + client.line2 + "<br>" + client.country);
					$("#previewClient").modal();
				}
			})
		});


		$("#addClient .btn-primary").click(e => {
			e.preventDefault();
			let data = $("#addbilling_form").serialize();
			data += "&op=addBilling&client=" + this.clientid;
			$.ajax({
				data: data,
				success: (result, s) => {
					let newid = result.id;

					$("#billingentity_id").html("");

					$(result.clients).each((i, ee) => {
						let opt = $("<option></option>").attr("value", ee.id).html(ee.name);
						$("#billingentity_id").append(opt);
					});

					$("#billingentity_id").val(newid).change();

					$("#addClient").modal('hide');

				}

			})
		});

		$("#_discount").change(() => {
			let discount = $("#_discount").val();
			discount = this.fix(discount);
			vm.$data.discount = discount;
			vm.update();
		}).change();

		// $("#show_tax").change((e) => {
		//        $("#tax_info_1, #tax_info_2").hide();
		//        if ($(e.target).prop("checked")) {
		//            $("#tax_info_1, #tax_info_2").show();
		//        } else {
		//        	$("#apply_vat").prop("checked", false).change();
		// 		}
		//    }
		// ).change();
	}

	fix(num) {

		if (isNaN(num)) {
			if (num == undefined) {
				return "";
			}
			if (num.split(",").length == 2) {
				return 1 * (num.split(",").join("."));
			}
			return 0;
		}
		return num;
	}

	stringTotal(total) {
		let converter = require('written-number');
		let t = total
		if (t == 0) {
			return ""
		}

		let string = "" + total
		if (string.indexOf(".") !== -1) {
			let arr = string.split(".");
			let first = converter(arr[0]);
			let second = converter(arr[1]);

			if (arr[1] !== '00') {
				return first + " point " + second;
			}
		}

		return converter(total);
	}


}

export default CreateQuotation;
